<template>
  <div>
    <form @submit.prevent="registerUser">
      <!-- User Email -->
      <div class="form-group row">
        <label class="col-4 col-form-label"
          >Email Address
          <span class="text-danger">*</span>
        </label>
        <div class="col-8"
          ><input
            v-model="form.useremail"
            type="email"
            class="form-control"
            :class="{
              'is-invalid': formsubmit && $v.form.useremail.$error,
            }"
          />
          <div
            v-if="formsubmit && $v.form.useremail.$error"
            class="invalid-feedback"
          >
            <span v-if="!$v.form.useremail.required"
              >This value is required.</span
            >
            <span v-else-if="!$v.form.useremail.email"
              >Email address is invalid.</span
            >
          </div>
        </div>
      </div>

      <!-- User Password -->
      <div class="form-group row">
        <label class="col-4 col-form-label"
          >Password
          <span class="text-danger">*</span>
        </label>
        <div class="col-8"
          ><input
            v-model="form.password"
            type="password"
            class="form-control"
            :class="{
              'is-invalid': formsubmit && $v.form.password.$error,
            }"
          />
          <div
            v-if="formsubmit && $v.form.password.$error"
            class="invalid-feedback"
          >
            <span v-if="!$v.form.password.required"
              >This value is required.</span
            >
            <span v-if="!$v.form.password.minLength"
              >Password should be at least 8 characters.</span
            >
            <span v-if="!$v.form.password.maxLength"
              >Password should be no more than 16 characters.</span
            >
          </div>
        </div>
      </div>

      <!-- Confirm Password -->
      <div class="form-group row">
        <label class="col-4 col-form-label"
          >Confirm Password
          <span class="text-danger">*</span>
        </label>
        <div class="col-8"
          ><input
            v-model="form.confirmPassword"
            type="password"
            class="form-control"
            :class="{
              'is-invalid': formsubmit && $v.form.confirmPassword.$error,
            }"
          />
          <div
            v-if="formsubmit && $v.form.confirmPassword.$error"
            class="invalid-feedback"
          >
            <span v-if="!$v.form.confirmPassword.required"
              >This value is required.</span
            >
            <span v-else-if="!$v.form.confirmPassword.sameAsPassword"
              >Confirm Password should be the same with Password.</span
            >
          </div>
        </div>
      </div>

      <!-- Account Number -->
      <div class="form-group row">
        <label class="col-4 col-form-label"
          >Account Number
          <span class="text-danger">*</span>
        </label>
        <div class="col-8"
          ><input
            v-model="form.accountNumber"
            type="text"
            class="form-control"
            :class="{
              'is-invalid': formsubmit && $v.form.accountNumber.$error,
            }"
          />
          <div>
            <span class="font-13">Indicated on your ND Energy invoice</span>
          </div>

          <div
            v-if="formsubmit && $v.form.accountNumber.$error"
            class="invalid-feedback"
          >
            <span v-if="!$v.form.accountNumber.required"
              >This value is required.</span
            >
            <span v-else-if="!$v.form.accountNumber.minLength"
              >Account number should be a 12-digit number.</span
            >
          </div>
        </div>
      </div>

      <!-- Access Code -->
      <div class="form-group row">
        <label class="col-4 col-form-label"
          >Access Code
          <span class="text-danger">*</span>
        </label>
        <div class="col-8"
          ><input
            v-model="form.accessCode"
            type="text"
            class="form-control"
            :class="{
              'is-invalid': formsubmit && $v.form.accessCode.$error,
            }"
          />
          <div>
            <span class="font-13">Indicated on your ND Energy invoice</span>
          </div>

          <div
            v-if="formsubmit && $v.form.accessCode.$error"
            class="invalid-feedback"
          >
            <span v-if="!$v.form.accessCode.required"
              >This value is required.</span
            >
            <span v-else-if="!$v.form.accessCode.minLength"
              >Access code should be a 8-digit number/letter.</span
            >
          </div>
        </div>
      </div>

      <!-- Action Button -->
      <div class="form-group row text-right mt-2">
        <div class="col-8 offset-4">
          <b-btn variant="danger" @click="registerUser">Register User</b-btn>
          <b-btn
            variant="secondary"
            class="m-l-5 ml-1"
            @click="$bvModal.hide('register-user')"
            >Cancel</b-btn
          >
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import {
  required,
  email,
  minLength,
  sameAs,
  maxLength,
} from 'vuelidate/lib/validators'
import { regPortalUser } from '@services'

export default {
  data() {
    return {
      formsubmit: false,

      form: {
        useremail: '',
        password: '',
        confirmPassword: '',
        accountNumber: '',
        accessCode: '',
      },
    }
  },

  validations: {
    form: {
      useremail: {
        required,
        email,
      },
      password: {
        required,
        minLength: minLength(8),
        maxLength: maxLength(16),
      },
      confirmPassword: {
        required,
        sameAsPassword: sameAs('password'),
      },
      accountNumber: {
        required,
        minLength: minLength(12),
      },
      accessCode: {
        required,
        minLength: minLength(8),
      },
    },
  },

  methods: {
    async registerUser() {
      this.formsubmit = true
      this.$v.$touch()

      if (!this.$v.$invalid) {
        const result = await regPortalUser({
          registeruser: this.form,
        })
        this.$swal({
          title: result.status,
          text: result.message,
          icon:result.status.toLowerCase(),
          confirmButtonColor:'#F1556C',

        })

        if (result.status === 'Success' || result.status === 'Info') {
          this.$bvModal.hide('register-user')
          this.$emit("UserRegisterCompleted")
        }
      }
    },
  },
}
</script>
